import React, { useState, useEffect } from "react";
import { Search, Eye } from "lucide-react";
import axios from "axios";
import { ORDER_API } from "../../../data/api";

const statusStyles = {
  Pending: "bg-yellow-100 text-yellow-700",
  Processing: "bg-blue-100 text-blue-700",
  Delivered: "bg-green-100 text-green-700",
};

const DeliveredOrder = () => {
  const [search, setSearch] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const vendorId = localStorage.getItem("vendorId");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);

        const url = vendorId
          ? `${ORDER_API.GET_ALL}/vendor/${vendorId}`
          : ORDER_API.GET_ALL;

        const response = await axios.get(url);
        const allOrders = Array.isArray(response.data) ? response.data : [];

        // Filter only Delivered orders
        const deliveredOrders = allOrders.filter(o => o.orderStatus === "Delivered");

        setOrders(deliveredOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [vendorId]);

  const filteredOrders = orders.filter((o) => {
    const productName = o.items?.[0]?.product?.productName || "";
    const customerName = o.customerName || o.user?.fullName || "";
    return (
      productName.toLowerCase().includes(search.toLowerCase()) ||
      customerName.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Delivered Orders</h1>

      <p className="mb-4 text-gray-600 font-medium">
        Total Delivered Orders: {orders.length}
      </p>

      {/* Search Input */}
      <div className="flex items-center gap-2 mb-4 bg-white rounded-xl shadow p-3 w-full md:w-1/3">
        <Search className="text-gray-500" />
        <input
          type="text"
          placeholder="Search product or customer..."
          className="w-full outline-none"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Orders Table */}
      <div className="bg-white shadow rounded-xl p-4 overflow-x-auto">
        {loading ? (
          <p className="text-center text-gray-500 p-4">Loading orders...</p>
        ) : filteredOrders.length > 0 ? (
          <table className="w-full">
            <thead>
              <tr className="text-left border-b">
                <th className="p-3">Order ID</th>
                <th className="p-3">Customer</th>
                <th className="p-3">Product</th>
                <th className="p-3">Amount</th>
                <th className="p-3">Delivered On</th>
                <th className="p-3">Status</th>
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) => (
                <tr
                  key={order.orderId || order.id}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="p-3 font-medium">{order.orderId || order.id}</td>
                  <td className="p-3">{order.customerName || order.user?.fullName || "N/A"}</td>
                  <td className="p-3">{order.items?.[0]?.product?.productName || "N/A"}</td>
                  <td className="p-3">₹{order.items?.[0]?.price || order.finalAmount}</td>
                  <td className="p-3">
                    {order.updatedAt
                      ? new Date(order.updatedAt).toLocaleDateString()
                      : new Date(order.createdAt).toLocaleDateString()}
                  </td>
                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        statusStyles[order.orderStatus] || "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {order.orderStatus}
                    </span>
                  </td>
                  <td className="p-3 flex items-center justify-center gap-3">
                    <button className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200">
                      <Eye size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-gray-500 p-4">No delivered orders found...</p>
        )}
      </div>
    </div>
  );
};

export default DeliveredOrder;
